var map = {
	"./gallery-spectrespecs_00.jpg": 2340,
	"./gallery-spectrespecs_01.jpg": 2341,
	"./gallery-spectrespecs_02.jpg": 2342,
	"./gallery-spectrespecs_03.jpg": 2343,
	"./gallery-spectrespecs_04.jpg": 2344,
	"./gallery_00.jpg": 2345,
	"./gallery_01.jpg": 2346,
	"./gallery_02.jpg": 2347,
	"./gallery_03.jpg": 2348,
	"./gallery_04.jpg": 2349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2339;